module.exports = __webpack_public_path__ + "img/small-1.378340a0.webp";